export default __webpack_public_path__ + "static/media/InvoiceIcon.fc1e2ec0.svg";